import React from 'react';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import styles from './styles.module.scss';

export default function MessageWrapper({ children }) {
  const { tokens } = useInterstateTheme();
  return (
    <div
      className={styles.container}
      style={{ '--message-border': tokens.SemColorBorderMuted, '--message-shadow': tokens.SemColorShadowMuted }}
    >
      <div className={styles.logoWrapper}>
        <img
          className={styles.logo}
          src={import.meta.env.BASE_URL + 'manheimLogo.svg'}
          alt="logo"
        />
      </div>
      {children}
    </div>
  );
}
